export default __webpack_public_path__ + "img/bold.5ed6d1b7.svg";